
import { useEffect, useState } from 'react';

interface LoadingScreenProps {
  onComplete: () => void;
}

export default function LoadingScreen({ onComplete }: LoadingScreenProps) {
  const [progress, setProgress] = useState(0);
  const [showSlogan, setShowSlogan] = useState(false);
  const [showLogo, setShowLogo] = useState(false);

  useEffect(() => {
    // 进度条动画
    const progressTimer = setInterval(() => {
      setProgress(prev => {
        if (prev >= 100) {
          clearInterval(progressTimer);
          setTimeout(onComplete, 500);
          return 100;
        }
        return prev + 2;
      });
    }, 50);

    // 显示slogan
    const sloganTimer = setTimeout(() => {
      setShowSlogan(true);
    }, 300);

    // 显示logo
    const logoTimer = setTimeout(() => {
      setShowLogo(true);
    }, 600);

    return () => {
      clearInterval(progressTimer);
      clearTimeout(sloganTimer);
      clearTimeout(logoTimer);
    };
  }, [onComplete]);

  return (
    <div className="fixed inset-0 bg-white z-50 flex flex-col items-center justify-center">
      {/* Slogan */}
      <div className={`mb-6 transition-all duration-800 ${showSlogan ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}>
        <p 
          className="text-lg text-[#2A2A2A] text-center tracking-wide"
          style={{ fontFamily: 'Noto Sans SC, sans-serif' }}
        >
          重塑年轻的权力
        </p>
      </div>

      {/* LUNAKEY Logo */}
      <div className={`mb-8 transition-all duration-800 ${showLogo ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}>
        <h1 
          className="text-3xl font-black text-[#2A2A2A] tracking-wider"
          style={{ fontFamily: 'Inter, sans-serif' }}
        >
          LUNAKEY
        </h1>
      </div>

      {/* 进度条 */}
      <div className="w-48 h-1 bg-gray-200 rounded-full overflow-hidden">
        <div 
          className="h-full bg-[#2A2A2A] rounded-full transition-all duration-100 ease-out"
          style={{ width: `${progress}%` }}
        />
      </div>
      
      <div className="mt-2 text-sm text-[#666] font-medium">
        {progress}%
      </div>
    </div>
  );
}
